export default {
    meta: {
        baseTitle:
            "Jacob Hurst | Software Development Engineer",
    },
    socials: [
        {
            url: "https://www.instagram.com/jacobhurst/",
            title: "Instagram",
            icon: "la-instagram",
        },
        {
            url: "https://www.linkedin.com/in/jacobdhurst/",
            title: "LinkedIn",
            icon: "la-linkedin-in",
        },
        {
            url: "https://github.com/jacobdhurst",
            title: "GitHub",
            icon: "la-github",
        },
    ],
    about: {
        title: "About",
        info: [
            {
                name: "Name",
                value: "Jacob Hurst",
            },
            {
                name: "Email",
                value: "jacob.hurst.94@gmail.com",
            },
            {
                name: "Job",
                value: "Software Development Engineer",
            },
        ],
        body: {
            header: "Background",
            text: `<p>I'm a software development engineer working on healthcare technology at Amazon, building systems and tools that support clinicians and patients.</p><p>Outside of work I enjoy running, gaming, brewing kombucha, baking, working out, traveling, and taking care of my pets.</p>`,
        },
        skills: [
            { title: "Java", progress: 90 },
            { title: "JavaScript", progress: 90 },
            { title: "Python", progress: 90 },
            { title: "Ruby", progress: 70 },
            { title: "TypeScript", progress: 90 },
            { title: "AWS", progress: 90 },
            { title: "Guice", progress: 80 },
            { title: "Spring", progress: 80 }
        ],
        services: [
            {
                icon: "la-code",
                header: "Development",
                description: "Experience designing and building distributed systems, APIs, AI tools, and platforms for large-scale production applications.",
            },
            {
                icon: "la-server",
                header: "Services",
                description: "Experience operating and scaling AWS cloud services with infrastructure as code, CI/CD, monitoring, operational reviews, and security reviews.",
            },
        ],
    },
    resume: {
        title: "Resume",
        education: [
            {
                title: "Bachelor of Engineering in Computer Science",
                subtitle: "University of New Mexico",
                date: {
                    start: "Aug 2015",
                    finish: "May 2019",
                },
                description: "Minor in Mathematics. Graduated Magna Cum Laude with a 3.7 GPA.",
            }
        ],
        experience: [
            {
                title: "Software Development Engineer II",
                subtitle: "Amazon — Amazon One Medical (Virtual Health Services Team)",
                date: {
                    start: "Oct 2023",
                    finish: "Present",
                },
                description:
                    "Building healthcare platform services and AI tooling supporting Amazon One Medical virtual care.",
                bullets: [
                    "Owned development of a clinical intake assistant subagent for a health AI chat platform using a graph-based architecture, enabling structured health data capture for providers and pharmacy systems.",
                    "Mentored an intern and led productionalization of an automated visit quality evaluation service, reducing manual review time by 5–10 hours weekly and establishing quality baselines and safety event flagging.",
                    "Built the organization's first production AI agent using Amazon Bedrock and Model Context Protocol (MCP) tools, enabling natural language querying of operational data through an internal dashboard.",
                    "Led design, development, and launch of Health Gateway, a contextual call-to-action service delivering dynamic widgets across the customer healthcare journey.",
                    "Implemented a centralized deletion orchestration service ensuring HIPAA-compliant deletion of customer health data across internal and partner systems.",
                    "Participated in a cross-organization away-team engagement integrating One Medical virtual care providers into a pay-per-visit model.",
                    "Delivered dashboards, alarms, runbooks, integration tests, canaries, and completed operational readiness and security review processes across services.",
                ],
            },
            {
                title: "Software Development Engineer II",
                subtitle: "Amazon — Amazon Business (Bulk Buying & Quoting Team)",
                date: {
                    start: "Jul 2019",
                    finish: "Oct 2023",
                },
                description:
                    "Developed distributed systems supporting bulk purchasing and quoting workflows for Amazon Business customers.",
                bullets: [
                    "Led design and launch of a retail quoting product coordinating three engineering teams and QA, generating $960K in converted revenue in the first month.",
                    "Resolved a critical service latency issue, reducing API response time from ~10 seconds to under 1 second.",
                    "Designed and implemented Salesforce integration for the planned spend quoting platform during a cross-organization away-team project.",
                    "Built a monitoring service detecting long-running workflow executions using scheduled invocations and DynamoDB-backed deduplication.",
                    "Implemented predictive traffic alarms across major service APIs and ingress points following a post-incident reliability review.",
                    "Led Prime Day and Q4 peak readiness initiatives and migrated services to AWS Graviton instances for improved efficiency.",
                    "Mentored interns and teammates and created architecture documentation and engineering knowledge-sharing sessions.",
                ],
            },
            {
                title: "Software Development Engineer (Contract)",
                subtitle: "Alliance DNA Laboratory",
                date: {
                    start: "Aug 2018",
                    finish: "May 2019",
                },
                description:
                    "Developed software supporting anthropological heritage analysis using DNA data.",
                bullets: [
                    "Developed Python software for DNA-based anthropological heritage data analysis.",
                    "Configured SQL databases storing genetic and population datasets.",
                    "Designed a frontend interface to generate and render analysis reports.",
                ],
            },
            {
                title: "Teaching Assistant",
                subtitle: "University of New Mexico",
                date: {
                    start: "Jan 2018",
                    finish: "May 2019",
                },
                description:
                    "Supported multiple Computer Science courses while coordinating teaching assistants and assisting students.",
                bullets: [
                    "Managed a team of four teaching assistants supporting over 200 students.",
                    "Held office hours and exam review sessions to assist students with coursework.",
                    "Collaborated with professors on grading, logistics, and course coordination.",
                ],
            },
            {
                title: "System Specialist",
                subtitle: "University of New Mexico",
                date: {
                    start: "Jan 2018",
                    finish: "May 2019",
                },
                description:
                    "Maintained servers, computer labs, and infrastructure for the Computer Science department.",
                bullets: [
                    "Managed accounts and workstation configurations using Puppet and Subversion.",
                    "Maintained lab and server infrastructure used by the department.",
                    "Troubleshot system outages and technical issues across department systems.",
                ],
            },
        ],
    },
    copyrightText: `Copyright &copy; ${new Date().getFullYear()} - All rights reserved`,
};